// Visibility rules for the dashboard's food-sourcing entry points.
// `marketplaceRelevant` comes from useNonprofitMarketplaceRelevance —
// always true for non-nonprofit accounts.

import { PATH_DASHBOARD } from 'src/routes/paths';
import { checkRoute } from 'src/utils/permissions';

export const shouldShowMarketplaceEntryPoints = ({
  user,
  marketplaceRelevant,
}) => !user?.marketplace_hidden && !user?.is_driver && !!marketplaceRelevant;

export const canSeeFindDonations = (user) =>
  !!user?.is_non_profit &&
  !user?.is_executive &&
  !user?.is_corporate &&
  (!user?.is_driver || !!user?.driver_can_view_open_donations);

// Any org that may post to Freshcue as a donor (it has an eligible program:
// nearby or linked, not blocked, from /user/me freshcue_donor_program_count)
// gets a "Post to Freshcue" entry point. The route policy keeps drivers and
// orgs blocked by the EIN gate out.
export const canPostToFreshcue = (user) =>
  !!user?.freshcue_donor_enabled &&
  !user?.is_executive &&
  !user?.is_corporate &&
  checkRoute(user, PATH_DASHBOARD.freshcue.businessPosts);
